﻿package org.zq.pixelset.model

enum class RotationStep(val degrees: Int, val label: String) {
    D0(0, "0°"),
    D90(90, "90°"),
    D180(180, "180°"),
    D270(270, "270°"),
    ;

    companion object {
        fun fromDegrees(degrees: Int): RotationStep =
            entries.find { it.degrees == degrees } ?: D0
    }
}

data class EditParams(
    val rotationDegrees: Int = 0,
    val cropLeft: Float = 0f,
    val cropTop: Float = 0f,
    val cropRight: Float = 0f,
    val cropBottom: Float = 0f,
    val visualCrop: NormalizedRect = NormalizedRect(),
    val useVisualCrop: Boolean = false,
    val brightness: Int = 0,
    val contrast: Float = 1f,
    val saturation: Float = 1f,
) {
    val hasMarginCrop: Boolean
        get() = !useVisualCrop && (cropLeft > 0f || cropTop > 0f || cropRight > 0f || cropBottom > 0f)

    val hasVisualCrop: Boolean
        get() = useVisualCrop && !visualCrop.isFullImage

    val hasCrop: Boolean
        get() = hasMarginCrop || hasVisualCrop

    val hasFilters: Boolean
        get() = brightness != 0 || contrast != 1f || saturation != 1f

    val hasEdits: Boolean
        get() = rotationDegrees != 0 || hasCrop || hasFilters
}
